import { FC, useEffect } from "react";

import { StudentDemoAIPrompt } from "./StudentDemoAIPrompt";

import { AdminSettingsForm } from "components/materials/home/admin/settings/AdminSettingsForm";
import { t } from "i18n/i18n";
import { useCapabilities } from "store/capability-hooks";
import { storeApi, useAppSelector } from "store/index";
import { selectIsEditModeEnabled } from "store/selectors";
import { isStudentDemoEnabled } from "utils/waffle-flags";

export const AdminSettingsPanel: FC = () => {
  const editModeEnabled = useAppSelector(selectIsEditModeEnabled);
  const { canAuthorOrg } = useCapabilities();
  const canEdit = editModeEnabled && canAuthorOrg;

  useEffect(() => {
    storeApi.orgs.list();
  }, []);

  return (
    <div className="h-full overflow-y-auto">
      <h3 className="h3 mb-2 mt-0 text-black-tint-40">{t("home.settings.institution_settings")}</h3>
      <AdminSettingsForm readOnly={!canEdit} />

      {isStudentDemoEnabled() && <StudentDemoAIPrompt readOnly={!canEdit} />}
    </div>
  );
};
